import { render, staticRenderFns } from "./TaskMaterialModal.vue?vue&type=template&id=4a117430&"
import script from "./TaskMaterialModal.vue?vue&type=script&lang=js&"
export * from "./TaskMaterialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a117430')) {
      api.createRecord('4a117430', component.options)
    } else {
      api.reload('4a117430', component.options)
    }
    module.hot.accept("./TaskMaterialModal.vue?vue&type=template&id=4a117430&", function () {
      api.rerender('4a117430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/TaskMaterialModal.vue"
export default component.exports